<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header
      title="Statusy"
      subtitle="Panel administratora"
      buttonLabel="Dodaj status"
      buttonLink="/admin/statuses/new"
      backButtonLabel="Wróć"
      backButtonLink="/admin/" />

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="thead-dark">
          <tr>
            <th scope="col" class="border-0">Nazwa statusu</th>
            <th scope="col" class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(status, index) of statuses"
            :key="'status-' + index">
            <td class="align-middle">
              <router-link :to="'/admin/statuses/' + status.id">
                <span 
                  class="status-badge"
                  :style="{ backgroundColor: status.color }">
                  {{ status.name }}
                </span>
              </router-link>
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="dark"
                @click.native="$router.push('/admin/statuses/' + status.id)"
                class="mr-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeStatus(status.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="statuses.length === 0">
            <td
              colspan="2"
              class="text-center">
              Brak statusów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'statuses',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data() {
    return {
      statuses: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      filters: {
        search: ''
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {};

      if (this.filters.search) {
        where.search = this.filters.search;
      }

      ListUtils.loadItemsData(this, {
        endpoint: '/system/statuses/items?page=' + this.currentPage,
        listField: 'statuses',
        pagination: true,
        params: {
          where,
          order: {
            column: this.orderColumn,
            direction: this.orderDirection
          }
        }
      });
    },
    removeStatus (statusID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/system/statuses/delete/',
        id: statusID,
        successTitle: 'Usunięto status',
        successText: 'Wybrany status został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten status?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie statusu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    clearFilters () {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: ''
      };

      this.loadFilteredData();
      this.$bus.emit('view-filters-reset');
    },
    searchWithFilters () {
      this.$bus.emit('pagination-reset');
      this.debouncedLoadFilteredData();
    }
  }
};
</script>

<style scoped>
.status-badge {
  display: inline-block;
  padding: 6px 16px;
  border-radius: 20px;
  color: #fff;
  font-weight: 500;
  font-size: 13px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
}

.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>

